import { render } from "./CropperView.vue?vue&type=template&id=b47abfb4"
import script from "./CropperView.vue?vue&type=script&lang=js"
export * from "./CropperView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__